<template>
  <PrimeTree v-bind.prop="props" :pt="passThrough" v-on="listeners">
    <!-- Forward every PrimeVue Tree slot transparently to the consumer -->
    <template
      v-for="name in Object.keys(slots)"
      :key="name"
      v-slot:[name]="slotProps"
    >
      <slot :name="name" v-bind="slotProps || {}" />
    </template>
  </PrimeTree>
</template>

<script setup lang="ts">
import { usePassThrough } from 'primevue/passthrough';
import PrimeTree from 'primevue/tree';
import { useListeners } from '../utils';
import type {
  MeridiaTreeEmits,
  MeridiaTreeProps,
  MeridiaTreeSlots,
  PassThroughMeridiaTree,
} from './types';

const props = defineProps<MeridiaTreeProps>();
const emit = defineEmits<MeridiaTreeEmits>();
const slots = defineSlots<MeridiaTreeSlots>();

// No Meridia-specific styling yet — empty defaults keep the passthrough hook in
// place so consumer `pt` flows through and theming can be added here later.
const passThrough = usePassThrough(
  props.pt,
  {},
  {
    mergeSections: false,
    mergeProps: true,
  }
) as PassThroughMeridiaTree;

const { listeners } = useListeners<MeridiaTreeEmits>(emit, PrimeTree);
</script>
